import * as React from "react"
import {Box, MenuItem, TextField, Typography, useTheme} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";

const useStyle = makeStyles(theme => {
    return {
        root: {
            display: "flex",
            "& > h1": {
                flexGrow: 1
            },
            "& > div > div.MuiTextField-root":{
                margin: theme.spacing(1, 2, 1, 0)
            }
        }
    }
})

function Select({label, allLabel, value, values, onChange}){
    return <TextField
        label={label}
        onChange={e => onChange(e.target.value)}
        value={value || 0}
        disabled={!values}
        variant="outlined"
        size="small"
        select
    >
        <MenuItem key={0} value={0}>{allLabel}</MenuItem>
        {values && values.map(item => <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>) || null}
    </TextField>
}

export default function ({customers, customerId, siteId, onChangeCustomerId, onChangeSiteId, heading, children}){
    const classes = useStyle(useTheme())
    const customer = customerId && customers && customers.map && customers.map[customerId];

    return <Box className={classes.root}>
        <Typography variant="h1">{heading}</Typography>
        <Box>
            <Select
                label="Customer"
                allLabel="All Customers"
                value={customerId}
                values={customers && customers.list}
                onChange={onChangeCustomerId}
            />
            <Select
                label="Site"
                allLabel="All Sites"
                value={siteId}
                values={customer && customer.sites}
                onChange={onChangeSiteId}
            />
            {children}
        </Box>
    </Box>
}
